import { render } from "./vp-message.vue?vue&type=template&id=29ca1d0a"
import script from "./vp-message.vue?vue&type=script&lang=js"
export * from "./vp-message.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__